"use strict";
/**
 * Created by rouven on 01.03.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var find_in_object_1 = __importDefault(require("@wikom/find-in-object"));
var GridAction_1 = __importDefault(require("../GridAction"));
var GridLink_1 = __importDefault(require("../GridLink"));
var BaseColumn_1 = __importDefault(require("./BaseColumn"));
var createActions = function (children, rowData, idx) {
    console.warn('ActionColumn is deprecated, please use RenderColumn instead.');
    return react_1["default"].Children.map(children, function (child) {
        if (react_1["default"].isValidElement(child) && child.type === GridAction_1["default"]) {
            return react_1["default"].cloneElement(child, {
                action: function () { return child.props.action((0, find_in_object_1["default"])(idx, rowData)); },
                rowData: rowData,
                idx: idx
            });
        }
        if (react_1["default"].isValidElement(child) && child.type === GridLink_1["default"]) {
            return react_1["default"].cloneElement(child, {
                to: child.props.to + '/' + (0, find_in_object_1["default"])(idx, rowData),
                rowData: rowData,
                idx: idx
            });
        }
        if (react_1["default"].isValidElement(child) && (typeof child.type === 'function' || typeof child.type === 'object')) {
            return react_1["default"].cloneElement(child, {
                rowData: rowData
            });
        }
        return child;
    });
};
var ActionColumn = function (_a) {
    var name = _a.name, rowData = _a.rowData, _b = _a.idx, idx = _b === void 0 ? 'id' : _b, children = _a.children, _c = _a.className, className = _c === void 0 ? 'text-nowrap' : _c, onClick = _a.onClick, rest = __rest(_a, ["name", "rowData", "idx", "children", "className", "onClick"]);
    var actions = createActions(children, rowData, idx);
    switch (typeof className) {
        case 'string':
            className += ' table-actioncell';
            break;
        case 'object':
            if (className.td) {
                className = className.td + ' table-actioncell';
            }
            break;
    }
    return (react_1["default"].createElement(BaseColumn_1["default"], __assign({}, rest, { rowData: rowData, idx: idx, className: className }), actions));
};
exports["default"] = ActionColumn;
